"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RankInput = RankInput;
var _react = _interopRequireDefault(require("react"));
var _Select = _interopRequireDefault(require("@mui/material/Select"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _material = require("@mui/material");
var _reactHookForm = require("react-hook-form");
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _FormHelperText = _interopRequireDefault(require("@mui/material/FormHelperText"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const rankings = Array.from({
  length: 25
}, (_, i) => i + 1).concat('UNRANKED');
function RankInput({
  control,
  field,
  label,
  errors,
  sx = {
    width: 132
  }
}) {
  const cleanField = field.replaceAll('_', '-');
  const hasError = Boolean(errors) && Boolean(errors[field]);
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: field,
    control: control,
    render: ({
      field: {
        onChange,
        value = '',
        ...rest
      }
    }) => {
      return /*#__PURE__*/_react.default.createElement(_FormControl.default, _extends({
        size: "small"
      }, hasError ? {
        error: true
      } : {}), /*#__PURE__*/_react.default.createElement(_material.InputLabel, {
        id: cleanField
      }, label), /*#__PURE__*/_react.default.createElement(_Select.default, {
        labelId: cleanField,
        id: cleanField + '-select',
        value: value,
        label: label,
        onChange: onChange,
        sx: sx
      }, rankings.map(rank => /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        key: rank,
        value: rank
      }, rank))), hasError ? /*#__PURE__*/_react.default.createElement(_FormHelperText.default, null, errors[field].message) : null);
    }
  });
}